import { Select, ISelectOption } from '@salecycle/ui-component-library';
import { Geolocation } from 'entities/campaign/rules';
import { allLocations, getReadableLabel, Location } from 'entities/campaign/rules/Geolocation';
import * as React from 'react';
import { useTranslation, TFunction } from 'react-i18next';
import { connect } from 'react-redux';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<Geolocation>;

const options = (t: TFunction<'campaigns'>) =>
  allLocations.map(x => ({
    value: x,
    label: getReadableLabel(x as Location, t),
  }));

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const { t } = useTranslation('campaigns');

  const onChange = (option: ISelectOption<string>) =>
    props.update(props.rulesetId, props.ruleIndex, {
      location: option.value as Location,
    });

  const optionsTranslated = options(t);

  return (
    <div data-testid="Geolocation">
      <Select
        ariaLabel={t('editor.geolocation.label')}
        label={t('editor.geolocation.label')}
        options={optionsTranslated}
        value={optionsTranslated.find(option => option.value === props.rule.location)}
        onChange={onChange}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
